import { AircraftStatus, IAircraftWeight } from './FleetManagmentClient.ts';
import { FrameType } from './FleetManagmentClient.ts';
import { IDefaultType } from './FleetManagmentClient.ts';

export const AIRCRAFT_STATUS_LABELS: { [key in AircraftStatus]: string} = {
    active: 'Operational',
    archived: 'Retired',
    grounded: 'Grounded',
};

export const AIRCRAFT_TYPE_LABELS: { [key in FrameType]: string} = {
    'fixed-wing': 'Fixed Wing',
    'rotary-wing': 'Multi-Rotor',
    other: 'Other'
};

export const AIRCRAFT_DEFAULT_LABELS: { [key in IDefaultType]: string} = {
    primary: 'Primary',
    backup: 'Backup'
};

export const AIRCRAFT_WEIGHT_LABELS: { [key in IAircraftWeight]: string} = {
    'under-250g': 'Under 250g',
    '250g-55lb': '250g - 55lb',
    'over-55lb': 'Over 55lb'
};
